import React from 'react'

import { VideoTrack } from '../../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useHumanParticipants } from '../../../../../webrtc/webRTCRoom'

import './FocusScreens.scss'

interface FocusScreensProps {
  screenIds: readonly number[]
}

const FocusScreens = ({ screenIds }: FocusScreensProps) => {
  const participants = useHumanParticipants()

  return (
    <div className="focus-screens-pane">
      {participants
        .filter((p) => screenIds.includes(p.id))
        .map((p) => (
          <div className="focus-screen-feed" key={p.id}>
            {p.tracks.screen && (
              <VideoTrack track={p.tracks.screen} objectFit="contain" />
            )}
          </div>
        ))}
    </div>
  )
}

export { FocusScreens }
